module.exports = __webpack_public_path__ + "img/AT0000002566840.c8d07e86.svg";